import {useMutation} from '@tanstack/react-query';
import queryClient from '@/utils/reactQueryClient';
import brandUpdaters, {CreateBrandPayload} from '@/api/updaters/brand';

function useCreateBrand(agencyId: string) {
  return useMutation({
    mutationKey: ['brand', 'create'],
    mutationFn: (data: CreateBrandPayload) =>
      brandUpdaters.createBrand({agencyId, data}),
    onSuccess: () => {
      queryClient.invalidateQueries(['organizationBrands']);
      queryClient.invalidateQueries(['subscription']);
    },
  });
}

export default useCreateBrand;
